// extracted by mini-css-extract-plugin
export default {"mintDetail":"MintDetail_mintDetail__duvmH","imageContainer":"MintDetail_imageContainer__9IkRz","bottom":"MintDetail_bottom__Mh9Di"};